import ajax from "@/core/http-request";

//数据请求
export const deviceApi = {
    save(data){
        return ajax.post('/dev/device/save', data)
    },
    query(condition){
        return ajax.get('/dev/device/page', { params: condition })
    },
    delete(ids){
        return ajax.post('/dev/device/del', ids)
    },
    importDevices(formData){
        return ajax.post('/dev/device/import', formData)
    },
    listChannels(condition){
        return ajax.get('/dev/channels/list', { params: condition })
    }
}

//数据请求
export const deviceModelApi = {
    save(data){
        return ajax.post('/dev/model/save', data)
    },
    query(condition){
        return ajax.get('/dev/model/page', { params: condition })
    },
    queryList(condition){
        return ajax.get('/dev/model/list', { params: condition })
    },
    delete(ids){
        return ajax.post('/dev/model/del', ids)
    }
}
